import React, { useEffect, useRef, useState } from "react";
import { Globe } from "lucide-react";

export default function ManagerHeader({
  t,
  isRTL,
  pageName,
  previewSlug,
  lang,
  setLang,
  onBack,
  onOpen,
  onSave,
  saving,
  onLogout,
}) {
  const [showLangMenu, setShowLangMenu] = useState(false);
  const langMenuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (langMenuRef.current && !langMenuRef.current.contains(e.target)) {
        setShowLangMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuPos = isRTL ? "left-0" : "right-0";

  return (
    <div className="sticky top-0 z-40 bg-white border-b">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          
          <button onClick={onBack} className="px-3 py-2 rounded-lg border hover:bg-gray-50">
            {t("manager.back", "Back")}
          </button>
          {/* Language Switcher */}
          <div className="relative" ref={langMenuRef}>
            
            <button
              onClick={() => setShowLangMenu((prev) => !prev)}
              className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 transition shadow-sm border"
            >
              <Globe className="w-5 h-5 text-gray-700" strokeWidth={1.8} />
            </button>

            {showLangMenu && (
              <div className={`absolute mt-2 ${menuPos} bg-white border rounded-xl shadow-lg w-40 py-2 z-50`}>
                {[
                  { code: "en", label: "English" },
                  { code: "ar", label: "العربية" },
                  { code: "he", label: "עברית" },
                ].map((l) => (
                  <button
                    key={l.code}
                    onClick={() => {
                      setLang(l.code);
                      setShowLangMenu(false);
                    }}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition ${
                      lang === l.code ? "bg-gray-100 font-semibold" : ""
                    }`}
                  >
                    {l.label}
                  </button>
                ))}
              </div>
            )}
          </div>


          <div>
            <div className="text-lg font-bold text-gray-900">{pageName || "Untitled"}</div>
            <div className="text-sm text-gray-500">/{previewSlug}</div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button onClick={onOpen} className="px-4 py-2 rounded-lg border hover:bg-gray-50">
            {t("manager.open", "Open")}
          </button>

          <button
            onClick={onSave}
            disabled={saving}
            className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
          >
            {saving ? t("manager.saving", "Saving...") : t("manager.save", "Save")}
          </button>

          <button onClick={onLogout} className="px-4 py-2 rounded-lg bg-gray-900 text-white hover:bg-black">
            {t("manager.logout", "Logout")}
          </button>
        </div>
      </div>
    </div>
  );
}